var map = {
	"./shared/benchmarks/benchmark-percentile-chart/index.js": [
		97524,
		[
			961,
			1699,
			2664,
			7524
		]
	],
	"./shared/benchmarks/benchmarks-list/index.js": [
		63671,
		[
			961,
			2664,
			3671
		]
	],
	"./shared/benchmarks/benchmarks-selector/index.js": [
		34622,
		[
			961,
			1699,
			2664,
			6144,
			4622
		]
	],
	"./shared/benchmarks/config/index.js": [
		89607,
		[
			1699,
			9607
		]
	],
	"./shared/benchmarks/hooks/index.js": [
		90715,
		[
			715
		]
	],
	"./shared/benchmarks/screens/index.js": [
		41894,
		[
			1699,
			1894
		]
	],
	"./shared/benchmarks/simple-store/index.js": [
		48615,
		[
			8615
		]
	],
	"./shared/copy-to-clipboard/index.js": [
		54848,
		[
			2664,
			4848
		]
	],
	"./views/index.js": [
		94951,
		[]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 86864;
module.exports = webpackAsyncContext;